import Button from "@mui/material/Button";
import PropTypes from "prop-types";
import {
  Stack,
  Typography,
  Box,
  Tab,
  Tabs,
  Modal,
  IconButton,
} from "@mui/material";
import { Close, DeleteOutline } from "@mui/icons-material";

import dayjs from "dayjs";
import "dayjs/locale/pt-br";

import { useEffect, useState } from "react";

import CardPaciente from "../../components/CardPaciente";
import { ReactComponent as IconEdit } from "../../images/iconEdit.svg";

import { ReactComponent as IconSuccess } from "../../images/dialogs/success.svg";
import { ReactComponent as IconWallet } from "../../images/iconWallet.svg";
import { useParams, useNavigate } from "react-router-dom";

import { dadosIniciais } from "./dadosIniciais";
import api from "../../services/api";
import PreencherDadosIniciais from "./preencherDadosIniciais";
import { validarData } from "../../utils/validarData";
import { formatDate } from "../../utils/formatarData";
import { ufList } from "../../utils/ufList";
import { isEmail, maskCEP } from "../../utils/validacaoDadosPaciente";

import { atualizarDadosPaciente } from "../../services/cadastroService";

import {
  FieldInputText,
  FieldDatePicker,
  FieldSelect,
  FieldAutocomplete,
  FieldInputMask,
} from "../../components/Fields";
import ButtonGoBack from "../../components/Buttons/outlinedGoback";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const styles = {
  title: {
    fontWeight: 600,
    fontSize: "24px",
    lineHeight: "32xpx",
    color: "#1E729F",
    fontFamily: "Nunito, sans-serif",
  },
  subtitle: {
    fontWeight: 500,
    fontSize: "20px",
    lineHeight: "28px",
    color: "#1E729F",
  },
  diamond: {
    fill: "#1E729F",
  },
  modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    textAlign: "center",
    zoom: "70%",
  },
  containerBoxShadow: {
    boxShadow: "0px 1px 8px 0px #00000026",
    padding: "16px",
    width: "100%",
    borderRadius: "5px",
  },
};

export default function DetalhesCadastro() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [value, setValue] = useState(0);
  const [editMode, setEditMode] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [openSalvar, setOpenSalvar] = useState(false);

  const [dadosIniciaisState, setDadosIniciaisState] = useState(dadosIniciais);
  const [isCepInvalid, setIsCepInvalid] = useState(false);
  const [sexoList, setSexoList] = useState([]);
  const [naturalidadeList, setNaturalidadeList] = useState([]);
  const [racaList, setRacaList] = useState([]);
  const [estadoCivilList, setEstadoCivilList] = useState([]);
  const [religiaoList, setReligiaoList] = useState([]);
  const [profissaoList, setProfissaoList] = useState([]);
  const [escolaridadeList, setEscolaridadeList] = useState([]);
  const [lateralidadeList, setLateralidadeList] = useState([]);
  const [tipoTrabalhoList, setTipoTrabalhoList] = useState([]);
  const [condicaoAtualList, setCondicaoAtualList] = useState([]);
  const [identidadeGeneroList, setIdentidadeGeneroList] = useState([]);
  const [municipioList, setMunicipioList] = useState([]);
  const [dataValida, setDataValida] = useState(true);
  const [emailValido, setEmailValido] = useState(true);

  const [telefones, setTelefones] = useState([{ telefone: "", nome: "" }]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      await Promise.all([
        getDadosIniciais(),
        getDataLateralidadeList(),
        getDataEstadoCivilList(),
        getDataReligiaoList(),
        getDataSexoList(),
        getDataEscolaridadeList(),
        getDataRacaList(),
        getDataNaturalidadeList(),
        getDataTipoTrabalhoList(),
        getDataCondicaoTrabalhoList(),
        getDataProfissaoList(),
        getIdentidadeGeneroList(),
      ]);
    } catch (error) {
      console.error("An error occurred during data fetching:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const getDadosIniciais = async () => {
    const { data } = await api.get(`/dadospaciente/${id}`);

    getMunicipioList(data.estadoNascimento.id);
    PreencherDadosIniciais(data, setDadosIniciaisState);
  };

  const getDataLateralidadeList = async () => {
    const { data } = await api.get("/lateralidade/");
    setLateralidadeList(data.data);
  };

  const getDataEstadoCivilList = async () => {
    const { data } = await api.get("/estadocivil/");
    setEstadoCivilList(data.data);
  };

  const getDataReligiaoList = async () => {
    const { data } = await api.get("/religiao/");
    setReligiaoList(data.data);
  };

  const getDataProfissaoList = async () => {
    const { data } = await api.get("/cbo/");

    setProfissaoList(data.cbo);
  };

  const getDataSexoList = async () => {
    const { data } = await api.get("/sexo/");
    setSexoList(data.data);
  };

  const getDataRacaList = async () => {
    const { data } = await api.get("/racacor/");
    setRacaList(data.data);
  };

  const getDataEscolaridadeList = async () => {
    const { data } = await api.get("/escolaridade/");
    setEscolaridadeList(data.data);
  };

  const getDataNaturalidadeList = async () => {
    const { data } = await api.get("/pais/");

    setNaturalidadeList(data.paises);
  };

  const getDataTipoTrabalhoList = async () => {
    const { data } = await api.get("/tipoTrabalho/");
    setTipoTrabalhoList(data.data);
  };

  const getDataCondicaoTrabalhoList = async () => {
    const { data } = await api.get("/condicaoTrabalho/");
    setCondicaoAtualList(data.data);
  };

  const getIdentidadeGeneroList = async () => {
    const { data } = await api.get("/identidadegenero/");
    setIdentidadeGeneroList(data.data);
  };

  const getMunicipioList = async (estadoNascimento) => {
    const { data } = await api.post("/city", {
      state_id: estadoNascimento,
    });

    setMunicipioList(data);
  };

  const createPhoneForm = () => {
    setTelefones([...telefones, { telefone: "", nome: "" }]);
  };

  const deletePhone = (index) => {
    const newData = [...telefones];
    newData.splice(index, 1);
    setTelefones(newData);
  };

  function handleTelefones(index, value, field) {
    const newData = [...telefones];
    newData[index][field] = value;

    setTelefones(newData);
  }

  function handleDataNascimento(e) {
    setDataValida(validarData(e.target.value));
    setDadosIniciaisState((prevState) => ({
      ...prevState,
      dataNascimento: e.target.value,
      dataNascimentoLabel: formatDate(e.target.value),
    }));
  }

  const handleEstado = async (uf_id) => {
    setDadosIniciaisState((prevState) => ({
      ...prevState,
      municipioNascimento: "",
      municipioNascimentoLabel: "",
    }));

    setMunicipioList([]);

    if (uf_id === undefined || uf_id === null) {
      setDadosIniciaisState((prevState) => ({
        ...prevState,
        estadoNascimento: "",
        estadoNascimentoLabel: "",
      }));

      return;
    }

    try {
      setDadosIniciaisState((prevState) => ({
        ...prevState,
        estadoNascimento: uf_id.codigo_uf,
        estadoNascimentoLabel: uf_id.unidade_federativa,
      }));

      const { data } = await api.post("/city", {
        state_id: uf_id.codigo_uf,
      });

      data.unshift({ co_ibge: "", no_descricao: "Selecione" });

      setMunicipioList(data);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  };

  const handleCep = (value) => {
    setDadosIniciaisState((prevState) => ({
      ...prevState,
      enderecoCep: maskCEP(value),
      enderecoNumero: "",
      enderecoComplemento: "",
    }));

    if (value.replace(/[^\d]/g, "").length === 8) {
      fetchCep(value);
    }
  };

  const fetchCep = async (cod) => {
    await fetch(`https://viacep.com.br/ws/${cod}/json/`)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.erro) {
          setDadosIniciaisState((prevState) => ({
            ...prevState,
            enderecoUf: "",
            enderecoBairro: "",
            enderecoLogradouro: "",
            enderecoMunicipio: "",
            enderecoIBGE: "",
          }));
          return;
        }

        setDadosIniciaisState((prevState) => ({
          ...prevState,
          enderecoUf: data.uf,
          enderecoBairro: data.bairro,
          enderecoLogradouro: data.logradouro,
          enderecoMunicipio: data.localidade,
          enderecoIBGE: data.ibge,
          enderecoCodigoUf: ufList.find(({ uf }) => uf === data.uf).codigo_uf,
        }));
      });
  };

  const handleClose = () => {
    setEditMode(false);
    setOpenSalvar(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const success = await atualizarDadosPaciente(dadosIniciaisState);

    if (success) {
      setOpenSalvar(true);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSetDadosIniciaisState = (value, field) => {
    setDadosIniciaisState((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  return (
    <>
      {isLoading ? null : (
        <Box pb="30px">
          <ButtonGoBack />
          <Box
            sx={{
              ...styles.containerBoxShadow,
            }}
          >
            <Typography sx={styles.title}>Meu perfil</Typography>
            {dadosIniciaisState.medicoResponsavel && (
              <Typography mt="16px" sx={styles.subtitle}>
                Profissional responsável: {dadosIniciaisState.medicoResponsavel}
              </Typography>
            )}
          </Box>

          <CardPaciente id={id} />
          <Box
            sx={{
              ...styles.containerBoxShadow,
            }}
          >
            <Box
              sx={{
                borderBottom: 1,
                borderColor: "divider",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Tabs value={value} onChange={handleChange} aria-label="center">
                <Tab
                  sx={{ textTransform: "none", fontSize: "1rem" }}
                  label="Dados pessoais"
                  {...a11yProps(0)}
                />
                <Tab
                  sx={{ textTransform: "none", fontSize: "1rem" }}
                  label="Endereço"
                  {...a11yProps(1)}
                />
                <Tab
                  sx={{ textTransform: "none", fontSize: "1rem" }}
                  label="Contato"
                  {...a11yProps(2)}
                />
              </Tabs>
              <Button onClick={() => setEditMode(!editMode)}>
                <IconEdit />
              </Button>
            </Box>
            <form autoComplete="off" onSubmit={handleSubmit}>
              <CustomTabPanel value={value} index={0}>
                <Stack
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(290px, 1fr))",
                    gap: 2,
                  }}
                >
                  <FieldInputText
                    label="ID"
                    value={dadosIniciaisState.id}
                    setValue={() => {}}
                    isEditField={editMode}
                    disabled={true}
                    required
                  />

                  <FieldInputText
                    label="Nome"
                    value={dadosIniciaisState.nome}
                    setValue={(e) => handleSetDadosIniciaisState(e, "nome")}
                    isEditField={editMode}
                    disabled={false}
                    required
                  />

                  <FieldInputText
                    label="Nome social"
                    value={dadosIniciaisState.nomeSocial}
                    setValue={(e) =>
                      handleSetDadosIniciaisState(e, "nomeSocial")
                    }
                    isEditField={editMode}
                    disabled={false}
                    required
                  />

                  <FieldInputText
                    label="Nome da mãe"
                    value={dadosIniciaisState.nomeMae}
                    setValue={(e) => handleSetDadosIniciaisState(e, "nomeMae")}
                    isEditField={editMode}
                    disabled={false}
                    required
                  />

                  <FieldInputText
                    label="Email"
                    value={dadosIniciaisState.email}
                    setValue={(e) => {
                      setEmailValido(isEmail(e));
                      handleSetDadosIniciaisState(e, "email");
                    }}
                    isEditField={editMode}
                    disabled={false}
                    required
                    type="email"
                    error={!emailValido}
                    helperText={emailValido ? "" : "Informe um email válido"}
                  />

                  <FieldDatePicker
                    label="Data de nascimento"
                    dataMinima={dayjs().subtract(18, "year")}
                    value={dadosIniciaisState.dataNascimento}
                    setValue={(e) => {
                      handleSetDadosIniciaisState(e, "dataNascimento");
                    }}
                    isEditField={editMode}
                    required
                  />

                  <FieldSelect
                    label="Naturalidade"
                    value={dadosIniciaisState.naturalidade || ""}
                    setValue={(e) => {
                      setDadosIniciaisState((prevState) => ({
                        ...prevState,
                        naturalidade: e,
                        naturalidadeLabel: naturalidadeList.find(
                          ({ co_id }) => co_id === e
                        ).no_nome,
                      }));
                    }}
                    items={naturalidadeList.map((c) => {
                      return { id: c.co_id, label: c.no_nome };
                    })}
                    isEditField={editMode}
                    required
                    id="demo-simple-select"
                  />
                  <FieldAutocomplete
                    label="Estado de nascimento"
                    disabled={dadosIniciaisState.naturalidade !== 23}
                    isEditField={editMode}
                    getOptionLabel={(option) => option.unidade_federativa}
                    options={ufList}
                    value={
                      ufList.find(
                        (option) =>
                          option.codigo_uf ===
                          dadosIniciaisState.estadoNascimento
                      ) || null
                    }
                    setValue={(event, value) => handleEstado(value)}
                    required
                  />

                  <FieldAutocomplete
                    label="Município de nascimento"
                    disabled={
                      municipioList?.length === 0 ||
                      dadosIniciaisState.naturalidade !== 23
                    }
                    isEditField={editMode}
                    getOptionLabel={(option) => option.no_descricao || null}
                    options={municipioList}
                    value={
                      municipioList
                        ? municipioList.find(
                            (option) =>
                              option.co_ibge ===
                              dadosIniciaisState.municipioNascimento
                          )
                        : null
                    }
                    setValue={(event, value) =>
                      setDadosIniciaisState((prevState) => ({
                        ...prevState,
                        municipioNascimento: value?.co_ibge,
                        municipioNascimentoLabel: value?.no_descricao,
                      }))
                    }
                    required
                  />

                  <FieldSelect
                    label="Sexo biológico"
                    value={dadosIniciaisState.sexoBiologico || ""}
                    setValue={(e) => {
                      setDadosIniciaisState((prevState) => ({
                        ...prevState,
                        sexoBiologico: e,
                        sexoBiologicoLabel: sexoList.find(
                          ({ co_id }) => co_id === e
                        ).no_descricao,
                      }));
                    }}
                    items={sexoList.map((c) => {
                      return { id: c.co_id, label: c.no_descricao };
                    })}
                    isEditField={editMode}
                    required
                    id="demo-simple-select"
                  />

                  <FieldSelect
                    label="Raça/Cor"
                    value={dadosIniciaisState.racaCor || ""}
                    setValue={(e) => {
                      setDadosIniciaisState((prevState) => ({
                        ...prevState,
                        racaCor: e,
                        racaCorLabel: racaList.find(({ co_id }) => co_id === e)
                          .no_descricao,
                      }));
                    }}
                    items={racaList.map((c) => {
                      return { id: c.co_id, label: c.no_descricao };
                    })}
                    isEditField={editMode}
                    required
                    id="demo-simple-select"
                  />

                  <FieldSelect
                    label="Identidade de gênero"
                    value={dadosIniciaisState.identidadeGenero || ""}
                    setValue={(e) => {
                      setDadosIniciaisState((prevState) => ({
                        ...prevState,
                        identidadeGenero: e,
                        identidadeGeneroLabel: identidadeGeneroList.find(
                          ({ co_id }) => co_id === e
                        ).no_descricao,
                      }));
                    }}
                    items={identidadeGeneroList.map((c) => {
                      return { id: c.co_id, label: c.no_descricao };
                    })}
                    isEditField={editMode}
                    id="demo-simple-select"
                  />

                  <FieldSelect
                    label="Estado civil"
                    value={dadosIniciaisState.estadoCivil || ""}
                    setValue={(e) => {
                      setDadosIniciaisState((prevState) => ({
                        ...prevState,
                        estadoCivil: e,
                        estadoCivilLabel: estadoCivilList.find(
                          ({ co_id }) => co_id === e
                        ).no_descricao,
                      }));
                    }}
                    items={estadoCivilList.map((c) => {
                      return { id: c.co_id, label: c.no_descricao };
                    })}
                    isEditField={editMode}
                    id="demo-simple-select"
                    required
                  />

                  <FieldSelect
                    label="Religião"
                    value={dadosIniciaisState.religiao || ""}
                    setValue={(e) => {
                      setDadosIniciaisState((prevState) => ({
                        ...prevState,
                        religiao: e,
                        religiaoLabel: religiaoList.find(
                          ({ co_id }) => co_id === e
                        ).no_descricao,
                      }));
                    }}
                    items={religiaoList.map((c) => {
                      return { id: c.co_id, label: c.no_descricao };
                    })}
                    isEditField={editMode}
                    id="demo-simple-select"
                  />

                  <FieldSelect
                    label="Lateralidade"
                    value={dadosIniciaisState.lateralidade || ""}
                    setValue={(e) => {
                      setDadosIniciaisState((prevState) => ({
                        ...prevState,
                        lateralidade: e,
                        lateralidadeLabel: lateralidadeList.find(
                          ({ co_id }) => co_id === e
                        ).no_descricao,
                      }));
                    }}
                    items={lateralidadeList.map((c) => {
                      return { id: c.co_id, label: c.no_descricao };
                    })}
                    isEditField={editMode}
                    id="demo-simple-select"
                  />

                  <FieldSelect
                    label="Escolaridade"
                    value={dadosIniciaisState.escolaridade || ""}
                    setValue={(e) => {
                      setDadosIniciaisState((prevState) => ({
                        ...prevState,
                        escolaridade: e,
                        escolaridadeLabel: escolaridadeList.find(
                          ({ co_id }) => co_id === e
                        ).no_descricao,
                      }));
                    }}
                    items={escolaridadeList.map((c) => {
                      return { id: c.co_id, label: c.no_descricao };
                    })}
                    isEditField={editMode}
                    id="demo-simple-select"
                    required
                  />

                  <FieldSelect
                    label="Profissão"
                    value={dadosIniciaisState.profissao || ""}
                    setValue={(e) => {
                      setDadosIniciaisState((prevState) => ({
                        ...prevState,
                        profissao: e,
                        profissaoLabel: profissaoList.find(
                          ({ co_id }) => co_id === e
                        ).no_descricao,
                      }));
                    }}
                    items={profissaoList.map((c) => {
                      return { id: c.co_id, label: c.no_descricao };
                    })}
                    isEditField={editMode}
                    id="demo-simple-select"
                    required
                  />

                  <FieldSelect
                    label="Tipo de trabalho"
                    value={dadosIniciaisState.tipoTrabalho || ""}
                    setValue={(e) => {
                      setDadosIniciaisState((prevState) => ({
                        ...prevState,
                        tipoTrabalho: e,
                        tipoTrabalhoLabel: tipoTrabalhoList.find(
                          ({ co_id }) => co_id === e
                        ).no_descricao,
                      }));
                    }}
                    items={tipoTrabalhoList.map((c) => {
                      return { id: c.co_id, label: c.no_descricao };
                    })}
                    isEditField={editMode}
                    id="demo-simple-select"
                  />

                  <FieldInputText
                    label="Últimas atividades profissionais"
                    value={dadosIniciaisState.ultimasAtividadesProfissionais}
                    setValue={(e) =>
                      handleSetDadosIniciaisState(
                        e,
                        "ultimasAtividadesProfissionais"
                      )
                    }
                    isEditField={editMode}
                    disabled={false}
                  />

                  <FieldSelect
                    label="Condição atual"
                    value={dadosIniciaisState.condicaoAtual || ""}
                    setValue={(e) => {
                      setDadosIniciaisState((prevState) => ({
                        ...prevState,
                        condicaoAtual: e,
                        condicaoAtualLabel: condicaoAtualList.find(
                          ({ co_id }) => co_id === e
                        ).no_descricao,
                      }));
                    }}
                    items={condicaoAtualList.map((c) => {
                      return { id: c.co_id, label: c.no_descricao };
                    })}
                    isEditField={editMode}
                    id="demo-simple-select"
                  />

                  <FieldInputText
                    label="Há quanto tempo?"
                    value={dadosIniciaisState.tempoCondicaoAtual}
                    setValue={(e) =>
                      handleSetDadosIniciaisState(e, "tempoCondicaoAtual")
                    }
                    isEditField={editMode}
                    disabled={false}
                  />
                </Stack>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                <Stack
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(290px, 1fr))",
                    gap: 2,
                  }}
                >
                  <FieldInputMask
                    mask="99999-999"
                    placeholder="99999-999"
                    label="CEP"
                    value={dadosIniciaisState.enderecoCep}
                    setValue={(value) => handleCep(value)}
                    isEditField={editMode}
                    error={isCepInvalid}
                    helperText={isCepInvalid ? "Informe um CEP válido" : ""}
                    onBlur={(event) => {
                      setIsCepInvalid(event.target.value.includes("_"));
                    }}
                    required
                  />

                  <FieldInputText
                    label="UF"
                    value={dadosIniciaisState.enderecoUf}
                    setValue={() => {}}
                    isEditField={editMode}
                    disabled={true}
                    required
                  />

                  <FieldInputText
                    label="Município"
                    value={dadosIniciaisState.enderecoMunicipio}
                    setValue={() => {}}
                    isEditField={editMode}
                    disabled={true}
                    required
                  />

                  <FieldInputText
                    label="Logradouro"
                    value={dadosIniciaisState.enderecoLogradouro}
                    setValue={() => {}}
                    isEditField={editMode}
                    disabled={true}
                    required
                  />

                  <FieldInputText
                    label="Bairro"
                    value={dadosIniciaisState.enderecoBairro}
                    setValue={() => {}}
                    isEditField={editMode}
                    disabled={true}
                    required
                  />
                  <FieldInputText
                    label="Número"
                    value={dadosIniciaisState.enderecoNumero}
                    setValue={(e) =>
                      handleSetDadosIniciaisState(e, "enderecoNumero")
                    }
                    isEditField={editMode}
                    type="number"
                  />
                  <FieldInputText
                    label="Complemento"
                    value={dadosIniciaisState.enderecoComplemento}
                    setValue={(e) =>
                      handleSetDadosIniciaisState(e, "enderecoComplemento")
                    }
                    isEditField={editMode}
                  />
                </Stack>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={2}>
                {telefones.map((tel, index) => {
                  return (
                    <Stack
                      sx={{
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fit, minmax(290px, 1fr))",
                        gap: 2,
                        mt: 1,
                      }}
                      key={index.toString()}
                    >
                      <FieldInputText
                        label="Nome"
                        value={tel.nome}
                        setValue={(value) =>
                          handleTelefones(index, value, "nome")
                        }
                        isEditField={editMode}
                        disabled={false}
                        placeholder="Nome"
                      />
                      <Box position="relative">
                        <FieldInputMask
                          mask="(99) 99999-9999"
                          placeholder="(99) 99999-9999"
                          value={tel.telefone}
                          setValue={(value) =>
                            handleTelefones(index, value, "telefone")
                          }
                          label="Número"
                          isEditField={editMode}
                          error={tel.telefone.includes("_")}
                          helperText={
                            tel.telefone.includes("_")
                              ? "Informe um Telefone válido"
                              : ""
                          }
                          type={"tel"}
                        />

                        <Box
                          sx={{
                            position: "absolute",
                            top: "26px",
                            right: 0,
                            background: "transparent !important",
                          }}
                        >
                          {telefones.length > 1 && (
                            <IconButton
                              disabled={!editMode}
                              onClick={() => deletePhone(index)}
                            >
                              <DeleteOutline
                                fontSize="medium"
                                sx={{ color: "#D85050" }}
                              />
                            </IconButton>
                          )}
                        </Box>
                      </Box>

                      <Box></Box>
                    </Stack>
                  );
                })}

                <Button
                  sx={{ mt: 3, mb: 3 }}
                  color="primary"
                  variant="contained"
                  onClick={createPhoneForm}
                >
                  Adicionar telefone
                </Button>
              </CustomTabPanel>
              <Stack
                direction="row"
                sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}
              >
                <Button
                  sx={{
                    textTransform: "none",
                    fontSize: "1.2rem",
                    display: editMode ? "default" : "none",
                  }}
                  variant="outlined"
                  onClick={() => setEditMode(false)}
                >
                  Cancelar
                </Button>
                <Button
                  sx={{
                    textTransform: "none",
                    fontSize: "1.2rem",
                    display: editMode ? "default" : "none",
                  }}
                  type="submit"
                  variant="contained"
                >
                  Salvar
                </Button>
              </Stack>

              <Modal open={openSalvar} onClose={handleClose}>
                <Box style={styles.modal}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      backgroundColor: "#3AB238 !important",
                      p: 2,
                    }}
                  >
                    <Stack direction="row" sx={{ gap: 2 }}>
                      <IconWallet />
                      <Typography
                        sx={{
                          color: "#FFFFFF",
                          fontSize: "1.5rem",
                          fontWeight: "bold",
                        }}
                      >
                        Dados salvos
                      </Typography>
                    </Stack>

                    <IconButton onClick={handleClose}>
                      <Close sx={{ color: "white" }} />
                    </IconButton>
                  </Box>
                  <Box sx={{ padding: "4rem 1rem" }}>
                    <IconSuccess width="8rem" height="6rem" />
                    <Typography
                      id="modal-modal-description"
                      sx={{
                        mt: 2,
                        color: "#3AB238",
                        fontSize: "1.5rem",
                        fontWeight: "bold",
                      }}
                    >
                      Dados salvos com sucesso
                    </Typography>
                  </Box>
                  <Stack direction="row" sx={{ float: "right", m: 2 }}>
                    <Button
                      sx={{
                        textTransform: "none",
                        color: "#3AB238",
                        border: "1px solid #3AB238",
                        fontSize: "1.1rem",
                      }}
                      variant="outlined"
                      onClick={() => {
                        handleClose();
                      }}
                    >
                      Voltar
                    </Button>
                  </Stack>
                </Box>
              </Modal>
            </form>
          </Box>
        </Box>
      )}
    </>
  );
}
